import React from 'react';

import { SimpleTooltip, ToggleSwitch } from '@neptune/shared/venus-ui';

type ScaleSwitchProps<T extends string> = {
  disabled?: boolean;
  selected: T;
  setScale: (scale: T) => void;
  disabledText?: string | null;
  scaleArray: T[];
  ariaLabel: string;
  scalesMap: Map<T, string>;
  predicate: (value: string) => value is T;
};

export const ScaleSwitch = <T extends string>({
  disabled,
  selected,
  scaleArray,
  scalesMap,
  setScale,
  predicate,
  disabledText,
  ariaLabel,
}: ScaleSwitchProps<T>) => {
  const handleValueChange = React.useCallback(
    (value: string) => {
      if (predicate(value)) {
        setScale(value);
      }
    },
    [predicate, setScale],
  );

  return (
    <SimpleTooltip content={disabled && disabledText ? disabledText : null}>
      <ToggleSwitch
        aria-label={ariaLabel}
        selected={selected}
        disabled={disabled}
        onValueChange={handleValueChange}
        width="fit-content"
      >
        {scaleArray.map((value) => (
          <ToggleSwitch.Button key={value.toString()} value={value}>
            {scalesMap.get(value)}
          </ToggleSwitch.Button>
        ))}
      </ToggleSwitch>
    </SimpleTooltip>
  );
};
